module.exports = __webpack_public_path__ + "static/img/draw_go.9ce7c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/draw_go.png
// module id = uPWx
// module chunks = 1